export default __webpack_public_path__ + "static/media/amparo-arte-3.ace05b44.webp";